import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import type { MultipleBetType, MyBet } from '@ps/web-sports-api-types';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { Odds } from '@swf/sports/components';
import { getMultipleName } from '@swf/sports/utils/getMultipleName';

import { TXTWCL_EW, TXTWCL_Single } from './Header.messages.json';
import styles from './Header.scss';
import ResultIcon from './components/ResultIcon/ResultIcon';

export interface Props extends Pick<MyBet, 'betType' | 'odds' | 'result' | 'numLines' | 'isSgm'> {
  stakeAmount: number;
  isEachWay?: boolean;
  currency: Currency;
}

const Header: React.FC<Props> = ({
  betType,
  odds,
  result,
  stakeAmount,
  isEachWay,
  numLines,
  currency,
  isSgm
}) => (
  <div className={styles.title}>
    {result && <ResultIcon result={result} />}

    <span>
      <CurrencyAmount dollarValue value={stakeAmount} currency={currency} />{' '}
      {numLines > 1 && `x ${numLines} `}
      {` `}-{` `}
      {betType === 'SINGLE' ? (
        <Translation {...TXTWCL_Single} />
      ) : (
        getMultipleName({
          betType: betType as unknown as MultipleBetType,
          numberOfLines: numLines,
          isEachWay,
          isSgm
        })
      )}
      {odds && (
        <>
          {` `}@ <Odds {...odds} />
        </>
      )}
      {isEachWay && (
        <>
          {` `}
          <Translation {...TXTWCL_EW} />
        </>
      )}
    </span>
  </div>
);

export default Header;
